import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../../utils/api";
import { shareVariantEndpoint } from "../../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const shareVariantAPI = createApi(shareVariantEndpoint, "POST");

const shareVariantSlice = createSlice({
  name: "ShareVariantSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(shareVariantAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(shareVariantAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(shareVariantAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default shareVariantSlice.reducer;
